import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOpciones = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "opciones",
		transform: "translate(255.732 2984.816)",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Trazado_6753",
			"data-name": "Trazado 6753",
			d: "M0,0H24V24H0Z",
			transform: "translate(-255.732 -2984.816)",
			fill: "none"
		}), /* @__PURE__ */ _jsx("path", {
			id: "Trazado_6754",
			"data-name": "Trazado 6754",
			d: "M6,10a2,2,0,1,0,2,2A2.006,2.006,0,0,0,6,10Zm12,0a2,2,0,1,0,2,2A2.006,2.006,0,0,0,18,10Zm-6,0a2,2,0,1,0,2,2A2.006,2.006,0,0,0,12,10Z",
			transform: "translate(-255.732 -2984.816)"
		})]
	})]
});
const ForwardRef = forwardRef(SvgOpciones);
export { ForwardRef as ReactComponent };
